<overlay-header>Mass Email from {{referringPage}}</overlay-header>
<mat-dialog-content>
    <h3 style="text-align:right;color: #3f51b5" translate>Mass Email</h3>
    <div style="margin-top:5px; text-align:right;">
        <span *ngIf="loginSettings.V10==false">{{defaultYear.SchoolName}} - {{defaultYear.Term}}</span>
        <span *ngIf="loginSettings.V10==true">{{defaultYear.SchoolName}} - {{defaultYear.AYIdentifier}}</span>
    </div>

    <div class="pull-left">
        <table>
            <tr>
                <td style="padding:5px;width: 100%">
                    <tyl-form-field style="width: 35%" label="From">
                        <mat-select [(ngModel)]="massEmail.From" style="width: 100%">
                            <mat-option [value]="currentUser.Email">{{currentUser.Email}}</mat-option>
                            <mat-option [value]="loginSettings.DefaultEmailReplyToAddress">
                                {{(loginSettings.V10 ? 'System\'s No-Reply Email Address' : 'Parent Notification
                                Default "From" Address') + ': ' + loginSettings.DefaultEmailReplyToAddress}}
                            </mat-option>
                        </mat-select>
                    </tyl-form-field>
                </td>
                <td>&nbsp;</td>
            </tr>
            <tr>
                <td style="padding:5px;display: flex">
                    <div style="margin-right: 10px;">
                        <a class="link" style="cursor: pointer;" (click)="showSelectRecipientsModal()">Select
                            Recipients</a>
                    </div>
                    <div>
                        <a class="link" style="cursor: pointer;" (click)="showViewRecipientsModal()">View Recipients</a>
                    </div>
                </td>
                <td>
                    &nbsp;
                </td>
            </tr>
            <tr>
                <td style="padding:5px;width: 100% ">
                    <tyl-form-field style="width: 50%" label="Subject">
                        <input matInput type="text" #subjectFieldRef [(ngModel)]="massEmail.Subject"
                            style="width:600px;" aria-label="Email Subject" />
                    </tyl-form-field>
                </td>
                <td>&nbsp;</td>
            </tr>
            <tr>
                <td style="padding:5px;">
                    <span style="padding-right:15px;">
                        Attachments
                    </span>
                    <span #attachmentFieldRef *ngFor="let attachment of massEmail.Attachments"
                        style="padding-right:15px;">
                        <span style="padding-right:5px;">{{attachment.OriginalFileName}}</span>
                        <img src="./assets/images/cancel.png" class="sis-header-icon"
                            (click)="deleteAttachment(attachment)" style="height:15px; cursor: pointer;" />
                    </span>
                </td>
                <td>&nbsp;</td>
            </tr>
            <tr>
                <td style="padding:5px;" colspan="2">
                    <tyl-checkbox id="chkCreateCommunicationLog" aria-label="Create Communication Log"
                        [(checked)]="massEmail.CreateCommunicationLog">
                        Create Communication Log entries
                    </tyl-checkbox>
            </tr>
        </table>
    </div>

    <div style="margin-top:10px;width:100%">
        <quill-editor #contentFieldRef [(ngModel)]="massEmail.Body" id="massEmailBody" name="massEmailBody"
            [style]="{'height': '50vh'}"></quill-editor>
    </div>
</mat-dialog-content>
<mat-dialog-actions #pageFooter class="sis-app-footer" style="position: sticky;padding: 0px;">
    <div class="flex-footer-left">
        <tyl-button image="add.png" label="Add Attachment" (clickEvent)="addAttachmentClick()"></tyl-button>
        <tyl-button *ngIf="false" style="float:right;" image="post.png" label="Export Addresses"
            (clickEvent)="exportAddressesClick()"></tyl-button>
    </div>
    <div class="flex-footer-right">
        <error-prompt [errorList]="errors"></error-prompt>
        <tyl-button style="float:right;" image="Preferences2.png" label="Preferences" (clickEvent)="preferencesClick()">
        </tyl-button>
        <tyl-button style="float:right;" image="emailbuttonnocircle.png" label="Send Test Email"
            (clickEvent)="sendTestEmail()">
        </tyl-button>
        <tyl-button style="float:right;" image="Checkmark.png" label="Send Emails" (clickEvent)="sendEmailsClick()">
        </tyl-button>
        <tyl-button style="float:right;" label="Cancel" image="Cancel.png" (clickEvent)="closeClick()"></tyl-button>
    </div>
</mat-dialog-actions>